/*
 * @author: liqian
 * @date: Do not Edit
 * @description:
 */
import xlsx from 'xlsx'

var parserXlsx = {
  parse: function (file, callback) {
    let that = this;
    let reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = ev => {
      let dataBinary = ev.target.result;
      let workBook = xlsx.read(dataBinary, {type: 'binary', cellDates: true})
      let workSheet = workBook.Sheets[workBook.SheetNames[0]]
      //   console.log(workSheet)
      const data = xlsx.utils.sheet_to_json(workSheet)
      // console.log(data)
      if (callback) {
        callback(data);
      }
    }
  },
  exportXls: function (data) {
    let worksheet = xlsx.utils.aoa_to_sheet(data);
    let workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, '第一页');
    xlsx.writeFile(workbook, this.getDate() + '样本明细.xlsx');
  },
  exportCybjfaXls: function (data, fileName) {
    let worksheet = xlsx.utils.aoa_to_sheet(data);
    let workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, '第一页');
    xlsx.writeFile(workbook, this.getDate() + '差异比较方案.xlsx');
  },
  exportOther: function (data, fileName) {
    let worksheet = xlsx.utils.aoa_to_sheet(data);
    let workbook = xlsx.utils.book_new();
    xlsx.utils.book_append_sheet(workbook, worksheet, '第一页');
    xlsx.writeFile(workbook, this.getDate() + `${fileName}.xlsx`);
  },

  getDate() {
    const now = new Date();
    const year = now.getFullYear(); // 获取当前年份，返回 4 位数字
    const month = now.getMonth() + 1; // 获取当前月份，返回 0 ~ 11，需要加 1
    const date = now.getDate(); // 获取当前日期，返回 1 ~ 31
    const hour = now.getHours(); // 获取当前小时数，返回 0 ~ 23
    const minute = now.getMinutes(); // 获取当前分钟数，返回 0 ~ 59
    const second = now.getSeconds(); // 获取当前秒数，返回 0 ~ 59
    return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
  }
}
export {parserXlsx}



// WEBPACK FOOTER //
// ./src/components/excel/excelParser.js